import styled from 'styled-components'

const Legend = ({
  legendItems,
  itemType,
  itemColors,
}: {
  legendItems?: any[]
  itemType?: string
  itemColors?: any[]
}) => {
  return (
    <LegendContainer>
      {legendItems && (
        <>
          {itemType === 'line' &&
            legendItems?.map((item, index) => (
              <div className='item'>
                <div className='line'>
                  <IconLine
                    itemColor={
                      itemColors && itemColors[index]
                        ? itemColors[index]
                        : 'cyan'
                    }
                  />
                </div>
                <div>{item}</div>
              </div>
            ))}
          {itemType === 'circle' &&
            legendItems?.map((item, index) => (
              <div className='item'>
                <div className='circle'>
                  <IconCircle
                    itemColor={
                      itemColors && itemColors[index]
                        ? itemColors[index]
                        : 'cyan'
                    }
                  />
                </div>
                <div>{item}</div>
              </div>
            ))}
          {itemType === 'square' &&
            legendItems?.map((item, index) => (
              <div className='item'>
                <div className='square'>
                  <IconSquare
                    itemColor={
                      itemColors && itemColors[index]
                        ? itemColors[index]
                        : 'cyan'
                    }
                  />
                </div>
                <div>{item}</div>
              </div>
            ))}
        </>
      )}
    </LegendContainer>
  )
}

const IconLine = ({ itemColor }: { itemColor: string }) => (
  <svg
    version='1.1'
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    x='0px'
    y='0px'
    width='16px'
    height='20px'
    viewBox='0 0 16 20'
    xmlSpace='preserve'
  >
    <path style={{ stroke: itemColor }} d='M1,10h14' />
  </svg>
)

const IconCircle = ({ itemColor }: { itemColor: string }) => (
  <svg
    version='1.1'
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    x='0px'
    y='0px'
    width='16px'
    height='20px'
    viewBox='0 0 16 20'
    xmlSpace='preserve'
  >
    <circle style={{ fill: itemColor }} cx='8' cy='10' r='6' />
  </svg>
)

const IconSquare = ({ itemColor }: { itemColor: string }) => (
  <svg
    version='1.1'
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    x='0px'
    y='0px'
    width='16px'
    height='20px'
    viewBox='0 0 16 20'
    xmlSpace='preserve'
  >
    <rect style={{ fill: itemColor }} x='1' y='1' width='14' height='14' />
  </svg>
)

const LegendContainer = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 1.4rem;
  @media only screen and (max-width: 600px) {
    font-size: 1.3rem;
  }
  div,
  img {
    display: inline-block;
  }

  .item {
    margin-right: 1.6rem;
    .line,
    .circle,
    .square {
      display: inline-block;
      vertical-align: top;
      margin-right: 4px;
    }
    .line {
      transform: rotate(-45deg);
      svg {
        top: 1px;
        @media only screen and (max-width: 600px) {
          top: 1px;
          right: -2px;
        }
        position: relative;
        stroke: cyan;
        stroke-width: 4px;
        stroke-linecap: round;
      }
    }
    .square {
      svg {
        top: 3px;
        @media only screen and (max-width: 600px) {
          top: 2px;
        }
        position: relative;
      }
    }
    .circle {
      svg {
        top: 5px;
        position: relative;
      }
    }
  }
`

export default Legend
